import { graphql } from '@/generated/gql';

export const INTAKE_REQUIREMENTS_QUERY = graphql(/* GraphQL */ `
  query IntakeRequirementsQuery($id: UUID!) {
    sevenbridges {
      chatSession(id: $id) {
        id
        status
        requirementsExtraction {
          id
          chatSessionId
          fileIds
          processingStatus
          extractedData
          enhancedData
          errorMessage
          createdAt
          updatedAt
        }
      }
    }
  }
`);
